/**
 * Define as configurações principais do Editor referente ao console.
 */
export const optionsConsole = {
  autoIndent: true,
  automaticLayout: true,
  cursorBlinking: 'blink',
  wordWrap: 'on',
  wrappingIndent: 'same',
  renderLineHighlight: 'none',
  scrollBeyondLastLine: false,
  quickSuggestions: false,
  contextmenu: true,
  minimap: {
    enabled: false,
  },
};

/**
 * Configura o comportamento do Editor.
 */
export const confConsole = {
  comments: {
    lineComment: '//',
  },
  brackets: [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
  ],
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
  surroundingPairs: [
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
};

/**
 * Define a linguagem utilizada pelo Editor do console.
 */
export const languageConsole = {
  defaultToken: '',
  ignoreCase: true,
  brackets: [
    { open: '{', close: '}', token: 'delimiter.curly' },
    { open: '[', close: ']', token: 'delimiter.square' },
    { open: '(', close: ')', token: 'delimiter.parenthesis' },
  ],
  keywords: ['erro', 'resultado', 'linha', 'coluna', 'mensagem', 'retornovalor', 'isencao'],
  typeKeywords: ['lista', 'nulo'],
  tokenizer: {
    root: [
      [
        /[a-zA-Z_][\w-]*/,
        {
          cases: {
            '@keywords': { token: 'keyword.$0' },
            '@default': '',
          },
        },
      ],
      [/[ \t\r\n]+/, ''],
      [/[{}()\[\]]/, '@brackets'],
      [/\d*\.\d+([eE][\-+]?\d+)?/, 'number.float'],
      [/\d+?/, 'number'],
      [/[;,.]/, 'delimiter'],
      [/"/, { token: 'string.quote', next: '@string' }],
    ],
    comment: [[/[\/][\/](.*)/, 'comment']],
    string: [
      [/[^\\"]+/, 'string'],
      [/\\./, 'string.escape.invalid'],
      [/"/, { token: 'string.quote', next: '@pop' }],
    ],
  },
};
